/**
 * LINKURIOUS CONFIDENTIAL
 * Copyright Linkurious SAS 2012 - 2018
 *
 * Created by maximeallex on 2018-07-19.
 */

'use strict';

import { Component } from '@angular/core';

@Component({
  selector: 'bubble-body',
  template: `<ng-content></ng-content>`
})
export class BubbleBodyComponent {}

@Component({
  selector: 'bubble-link',
  template: `<ng-content></ng-content>`,
  styles: [
    'a { float: right; margin-top: 15px}'
  ]
})
export class BubbleLinkComponent {}
